function setSelectedVariant(element) {
  // Get necessary attributes
  let variantId = element.getAttribute("data-variant-id");
  let productId = element.getAttribute("data-product-id");
  let variantAvailable = element.getAttribute("available") === "true";

  //   console.log("Selected Variant ID:", variantId);

  // Update hidden input value
  let hiddenInput = document.querySelector("#sv_" + productId);
  if (hiddenInput) {
    hiddenInput.setAttribute("value", variantId);
  }

  // Update submit button state
  let submitButton = document.querySelector(
    "#ProductSubmitButton_" + productId
  );
  let buttonText = document.querySelector("#ProductButtonText_" + productId);

  if (submitButton && buttonText) {
    if (variantAvailable) {
      submitButton.removeAttribute("disabled");
      buttonText.textContent = "Add to Cart";
    } else {
      submitButton.setAttribute("disabled", "true");
      buttonText.textContent = "Sold out";
    }
  }

  // Update selected class
  let previouslySelectedElements = document.querySelectorAll(
    ".variant-link.selected"
  );
  previouslySelectedElements.forEach((el) => el.classList.remove("selected"));
  element.classList.add("selected");
}

// Select the first variant on page load
document.addEventListener("DOMContentLoaded", function () {
  let firstSelectedVariant = document.querySelector(".variant-link.selected");
  if (firstSelectedVariant) {
    setSelectedVariant(firstSelectedVariant);
  }
});
